export enum HelpSourceType {
    General = "General",

    LpGeneral = "LpGeneral",
    LpBanking = "LpBanking",
    LpDocument = "LpDocument",
    
    GpGeneral = "GpGeneral",
    GpBanking = "GpBanking",

}


export namespace HelpSourceType {
    export function toString(sourceType: HelpSourceType): string {
        switch (sourceType) {
            case HelpSourceType.General:
                return 'Form';
            case HelpSourceType.LpGeneral:
                return 'LP Portal - General';
            case HelpSourceType.LpBanking:
                return 'LP Portal - Banking';
            case HelpSourceType.GpGeneral:
                return 'GP Portal - General';
            case HelpSourceType.GpBanking:
                return 'GP Portal - Banking';
            default:
                return 'Form';
        }
    }

    export function parse(str: string): HelpSourceType {
        return HelpSourceType[str];
    }
}

export default HelpSourceType;